import React, { Suspense, lazy, useState, useEffect } from "react"; // <-- useState ve useEffect'i ekledik
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import SiteHeader from "components/SiteHeader";
import HowItWorksButton from "components/HowItWorksButton";

// --- PERFORMANS İYİLEŞTİRMESİ ---
// Sayfa ilk açıldığında görünmeyen component'leri 'lazy' ile import ediyoruz.
// Bu component'ler sadece ihtiyaç duyulduğunda yüklenecek.
const Card = lazy(() => import("components/ui/card").then(module => ({ default: module.Card })));
const CardContent = lazy(() => import("components/ui/card").then(module => ({ default: module.CardContent })));
const CardHeader = lazy(() => import("components/ui/card").then(module => ({ default: module.CardHeader })));
const CardTitle = lazy(() => import("components/ui/card").then(module => ({ default: module.CardTitle })));
const Sparkles = lazy(() => import("lucide-react").then(module => ({ default: module.Sparkles })));
const FAQ = lazy(() => import("components/FAQ"));
const Steps = lazy(() => import("components/Steps"));
const SecurityBanner = lazy(() => import("components/SecurityBanner"));
const MarqueeStrip = lazy(() => import("components/MarqueeStrip"));


// MarqueeStrip için optimize edilmiş, küçük boyutlu görseller.
// Her bir görselin hem .webp hem de .jpg formatında "thumbnail" versiyonlarını oluşturmalısınız.
const MARQUEE_THUMBNAILS = [
  {
    // Bu görselin .webp versiyonu var (masaüstü hero görseli).
    // NOT: Bu bir thumbnail değil, büyük bir dosya.
    webpSrc: "/galeri/wedding-anasayfa-web.webp",
    jpegSrc: "/galeri/wedding-anasayfa-desktop.jpg",
    alt: "Düğün masasından bir an"
  },
  {
    // DİKKAT: Bu görselin .webp versiyonu sunucuda yok.
    // Şimdilik her iki alana da .jpeg dosyasını yazıyoruz.
    webpSrc: "/galeri/wedding-slayt.jpeg",
    jpegSrc: "/galeri/wedding-slayt.jpeg",
    alt: "Dans eden gelin ve damat"
  },
  {
    // DİKKAT: Bu görselin de .webp versiyonu sunucuda yok.
    // Her iki alana da .jpg dosyasını yazıyoruz.
    webpSrc: "/galeri/slayt-2.jpg",
    jpegSrc: "/galeri/slayt-2.jpg",
    alt: "Gelin buketi detayı"
  },
  {
    // Bu görselin hem .webp hem de .jpg versiyonu var.
    webpSrc: "/galeri/furkan-hacer.webp",
    jpegSrc: "/galeri/furkan-hacer.jpg",
    alt: "Ornek dugun 1"
  },

];

const MARQUEE_THUMBNAILS2 = [
  {
    // Bu görselin hem .webp hem de .jpg versiyonu var.
    webpSrc: "/galeri/slayt-3.webp",
    jpegSrc: "/galeri/slayt-3.jpg",
    alt: "Düğün pastası"
  },
  {
    // Bu görselin hem .webp hem de .jpg versiyonu var.
    webpSrc: "/galeri/furkan-hacer.webp",
    jpegSrc: "/galeri/furkan-hacer.jpg",
    alt: "Ornek dugun 1"
  },
  {
    // Bu görselin hem .webp hem de .jpg versiyonu var.
    webpSrc: "/galeri/mustafa-aysegul.webp",
    jpegSrc: "/galeri/mustafa-aysegul.jpg",
    alt: "Ornek nisan 1"
  },

]

// Özellikler
const FEATURES = [
  { t: "Masalara özel veya tek QR ile yükleme", d: "Misafirleriniz herhangi bir uygulama indirmeden, internet sitesinden kolaylıkla fotoğraflarını yüklesin." },
  { t: "Fotoğraf, video ve ses desteği", d: "İçeriklerin kalitesi düşmeden yüklenme ve görüntülenme." },
  { t: "İçerikleriniz size özel", d: "Güvenli kullanım için içeriklerinize sadece size özel bilgiler ile erişin." },
  { t: "Gece sonunda içerikler tek yerde", d: "Tüm içerikleri size özel albümlerde toplayın." },
  { t: "Otomatik klasörleme ve favoriler", d: "Yüklenen içerikleri görüntüleyin, indirin veya silin." },
  { t: "Yalınlık ve Basitlik", d: "Fotoğraf, video veya ses kaydı göndermek için uygulama indirmeye gerek yok!" },
];

// Yorumlar — Metin Yorumları
const REVIEWS = [
  { name: "Dilara", date: "18 Mart 2026", text: "Bu fiyata böyle iyi bir hizmet bulduğum için mutluyum.", avatar: "👰" },
  { name: "Nursel", date: "27 Mart 2026", text: "Sınırsız depolama gerçekten sınırsız depolamaymış, bazı firmalar gibi sözleşme içine gizli maddeler konulmamış. Açık ve şeffaf bir hizmet.", avatar: "👩" },
  { name: "Ece", date: "2 Nisan 2026", text: "Gerek tasarım konusunda ilgileri, gerek sundukları hizmet için teşekkür ederim.", avatar: "💃" },
  { name: "Eren", date: "18 Nisan 2026", text: "Yıllar sonra o özel güne ait fotoğraf ve videolarımız unutulup gitmeyecek. Teşekkür ederiz.", avatar: "🤵" },
  { name: "Müşteri", date: "Nisan 2026", text: "Çok teşekkür ederim gönderdim ücreti. Güvenciniz için ayrıca teşekkürler.", avatar: "🙏" },
  { name: "Müşteri", date: "Nisan 2026", text: "Kargoyu teslim aldım emeğinize sağlık, paylaştığınız not çok ince bir davranış onun içinde teşekkür ederim.", avatar: "❤️" },
];

// Ekran Görüntüleri (public/galeri/ klasörüne atanız)
const SCREENSHOT_REVIEWS = [
  { src: "/galeri/yorum-1.jpeg", alt: "Müşteri yorumu Instagram ekran görüntüsü", platform: "instagram" },
  { src: "/galeri/yorum-2.jpeg", alt: "Müşteri yorumu WhatsApp ekran görüntüsü", platform: "whatsapp" },
  { src: "/galeri/yorum-3.jpeg", alt: "Müşteri yorumu Instagram ekran görüntüsü", platform: "instagram" },
];

// Animasyon variant'ları
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.3 } },
};

const childVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const sloganParts = [
  { text: "Anıların aurası, sonsuza kadar", fontFamily: "'Cormorant Garamond', serif", fontStyle: 'normal', weight: 300 },
  { text: "Anora", fontFamily: "'Cormorant Garamond', serif", fontStyle: 'normal', weight: 300, color: '#FECDD3' },
  { text: "ile.", fontFamily: "'Cormorant Garamond', serif", fontStyle: 'normal', weight: 300 },
];

export default function HomePage() {
  const [isMobile, setIsMobile] = useState(false);

  // 2. Ekran genişliğini kontrol eden fonksiyon
  const checkIsMobile = () => {
    // 768px popüler bir "breakpoint"tir (md:grid-cols-2 gibi Tailwind sınıflarıyla uyumludur)
    setIsMobile(window.innerWidth < 768);
  };

  // 3. Component yüklendiğinde ve pencere boyutu değiştiğinde çalışacak kısım
  useEffect(() => {
    // İlk yüklemede kontrol et
    checkIsMobile();

    // Pencere boyutu değiştiğinde de kontrol et
    window.addEventListener('resize', checkIsMobile);

    // Temizlik fonksiyonu: Component kaldırılırken dinleyiciyi sil (performans için kritik)
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // 4. Hız Değerlerini Belirleme
  const marqueeSpeed1 = isMobile ? 14 : 28; // Mobilde 14s (Hızlı), Web'de 28s (Yavaş)
  const marqueeSpeed2 = isMobile ? 16 : 32; // Mobilde 16s (Hızlı), Web'de 32s (Yavaş)

  return (
    <div className="min-h-dvh bg-background text-foreground overflow-hidden">
      <SiteHeader />
      <div className="h-16 md:h-20"></div>

      {/* ========================================================== */}
      {/* === YENİ HERO BÖLÜMÜ (ÇÖZÜM A) BAŞLANGICI === */}
      {/* ========================================================== */}
      <section className="w-full" style={{ backgroundColor: 'var(--bg, #FFF6F9)' }}>
        <div className="container mx-auto grid md:grid-cols-2">

          {/* --- SOL TARAF: METİN VE BUTON --- */}
          <div className="flex flex-col items-center justify-center text-center md:items-start md:text-left p-8 order-2 md:order-1 min-h-[50vh] md:min-h-[70vh]">

            <motion.h1
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="text-5xl sm:text-6xl"
              style={{ color: 'var(--ink, #2A2A2A)' }}
            >
              {sloganParts.map((part, index) => (
                <motion.span
                  key={index}
                  variants={childVariants}
                  style={{
                    display: 'block',
                    fontFamily: part.fontFamily,
                    fontWeight: part.weight,
                    fontStyle: part.fontStyle,
                    color: part.color === '#FECDD3' ? 'var(--primary-500)' : 'inherit',
                    lineHeight: 1.2,
                  }}
                >
                  {part.text}
                </motion.span>
              ))}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.6 }}
              className="mt-4 max-w-md text-neutral-600"
              style={{ color: 'var(--ink-soft, #525252)' }}
            >
              Düğün gününüzdeki tüm anıları misafirlerinizden kolayca toplayın ve tek bir yerde birleştirin.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 0.6 }}
              className="mt-8 flex flex-col sm:flex-row items-center sm:items-start justify-center md:justify-start w-full gap-4"
            >
              <HowItWorksButton />

              <a
                href="https://www.instagram.com/anoraforever.co"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center gap-3 bg-white/80 backdrop-blur-sm border-2 border-pink-100 hover:border-pink-200 px-6 py-3.5 rounded-full shadow-sm hover:shadow-md hover:bg-white transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] shadow-sm group-hover:scale-110 group-hover:shadow-md transition-all duration-300">
                  <Instagram className="w-5 h-5 text-white" />
                </div>
                <span className="text-[17px] font-bold text-gray-700">Instagram Sayfamız</span>
              </a>
            </motion.div>

          </div>

          {/* --- SAĞ TARAF: GÖRSEL --- */}
          <div className="relative min-h-[300px] h-[50vh] md:h-auto order-1 md:order-2">
            <picture className="absolute inset-0 w-full h-full">
              {/* Mobil İçin Dikey Görsel */}
              <source
                media="(max-width: 768px)"
                srcSet="/galeri/wedding-anasayfa-mobil.webp"
                type="image/webp"
              />
              {/* Masaüstü İçin Yatay Görsel */}
              <source
                media="(min-width: 769px)"
                srcSet="/galeri/wedding-anasayfa-web.webp"
                type="image/webp"
              />
              {/* Yedek JPEG Görseli */}
              <img
                src="/galeri/wedding-anasayfa-web.webp"
                alt="Mutlu çift"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </picture>
          </div>

        </div>
      </section>
      {/* ========================================================== */}
      {/* === YENİ HERO BÖLÜMÜ BİTİŞİ === */}
      {/* ========================================================== */}

      <main className="bg-gradient-to-b from-rose-50 via-pink-50 to-white flex-1 flex flex-col">
        <div className="flex-grow">
          <Suspense fallback={<div className="text-center p-12">Yükleniyor...</div>}>
            <section id="kayan" className="py-10 overflow-hidden">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 space-y-4">
                <MarqueeStrip
                  key={marqueeSpeed1} // Hız değiştiğinde component yeniden kurulur
                  images={MARQUEE_THUMBNAILS}
                  speed={marqueeSpeed1}
                />
                <MarqueeStrip
                  key={marqueeSpeed2} // Hız değiştiğinde component yeniden kurulur
                  images={MARQUEE_THUMBNAILS2}
                  reverse
                  speed={marqueeSpeed2}
                />
              </div>
            </section>

            <Steps />
            <SecurityBanner />

            <section id="ozellikler" className="py-12 scroll-mt-16 md:scroll-mt-20">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-center mb-10 text-neutral-900">
                  Özelliklerimiz
                </h2>
                <div className="grid md:grid-cols-3 gap-6">
                  {FEATURES.map((f, i) => (
                    <Card
                      key={i}
                      className="border-rose-100 hover:shadow-md transition-shadow text-center"
                    >
                      {/* ✅ Header ortalandı */}
                      <CardHeader className="flex flex-col items-center justify-center gap-3 pb-0">
                        <div className="size-9 rounded-xl bg-rose-500/10 text-rose-700 grid place-items-center">
                          <Sparkles className="w-5 h-5" />
                        </div>
                        <CardTitle className="text-base font-semibold">{f.t}</CardTitle>
                      </CardHeader>

                      {/* ✅ İçerik ortalandı */}
                      <CardContent className="flex flex-col items-center justify-center text-center pt-2">
                        <p className="text-sm text-neutral-600 leading-relaxed max-w-xs">
                          {f.d}
                        </p>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </div>
            </section>

            {/* MÜŞTERİ YORUMLARI — Premium Tasarım */}
            <section id="yorumlar" className="py-16 bg-gradient-to-b from-white/80 via-rose-50/30 to-white/80 scroll-mt-16 md:scroll-mt-20">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                {/* Başlık */}
                <div className="text-center mb-12">
                  <p className="text-sm font-semibold text-[#E45078] tracking-widest uppercase mb-2">❤️ Gerçek Müşteri Deneyimleri</p>
                  <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-neutral-900">
                    Mutlu Çiftlerimiz Ne Diyor?
                  </h2>
                  <p className="mt-3 text-neutral-500 max-w-lg mx-auto">Her düğün bizim için özel. İşte sizden önce bu deneyimi yaşayan çiftlerin gerçek mesajları.</p>
                </div>

                {/* 1. SATIR: Metin Yorumları (Yatay Kaydırılır Kart Tasarımı) */}
                <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide mb-10" style={{ scrollbarWidth: 'none' }}>
                  {REVIEWS.map((review, idx) => (
                    <div
                      key={idx}
                      className="snap-center shrink-0 w-[300px] sm:w-[340px] bg-white rounded-2xl border border-rose-100/60 p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col"
                    >
                      {/* Yıldızlar */}
                      <div className="flex gap-0.5 mb-3">
                        {[1, 2, 3, 4, 5].map(s => (
                          <svg key={s} className="w-4 h-4 text-amber-400 fill-current" viewBox="0 0 24 24"><path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" /></svg>
                        ))}
                      </div>
                      {/* Yorum Metni */}
                      <p className="text-neutral-600 text-sm italic leading-relaxed flex-grow">
                        “{review.text}”
                      </p>
                      {/* Yazar */}
                      <div className="flex items-center gap-3 mt-4 pt-3 border-t border-rose-50">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose-100 to-pink-50 flex items-center justify-center text-lg">
                          {review.avatar}
                        </div>
                        <div>
                          <p className="font-semibold text-neutral-800 text-sm">{review.name}</p>
                          <p className="text-xs text-neutral-400">{review.date}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* 2. SATIR: Ekran Görüntüleri + Video */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-start">
                  {/* Ekran Görüntüleri */}
                  {SCREENSHOT_REVIEWS.map((ss, idx) => (
                    <div
                      key={idx}
                      className="group relative rounded-2xl overflow-hidden border-2 border-rose-100/50 shadow-sm hover:shadow-xl hover:border-rose-200 transition-all duration-300 hover:-translate-y-1 bg-white"
                    >
                      {ss.platform === 'instagram' ? (
                        <div className="absolute top-3 left-3 z-10 flex items-center gap-1.5 bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow-md">
                          <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                          Instagram
                        </div>
                      ) : (
                        <div className="absolute top-3 left-3 z-10 flex items-center gap-1.5 bg-green-500 text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow-md">
                          <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" /><path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492l4.632-1.467A11.932 11.932 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818c-2.168 0-4.19-.586-5.932-1.605l-.424-.254-2.747.87.869-2.714-.267-.434A9.776 9.776 0 012.182 12 9.818 9.818 0 0112 2.182 9.818 9.818 0 0121.818 12 9.818 9.818 0 0112 21.818z" /></svg>
                          WhatsApp
                        </div>
                      )}
                      <img
                        src={ss.src}
                        alt={ss.alt}
                        className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                  ))}

                  {/* Video Testimonial */}
                  <div className="relative rounded-2xl overflow-hidden border-2 border-rose-100/50 shadow-sm hover:shadow-xl hover:border-rose-200 transition-all duration-300 hover:-translate-y-1 bg-black aspect-[9/16] flex items-center justify-center">
                    <div className="absolute top-3 left-3 z-10 flex items-center gap-1.5 bg-[#E45078] text-white text-[10px] font-bold px-2.5 py-1 rounded-full shadow-md">
                      🎥 Video
                    </div>
                    <video
                      className="w-full h-full object-cover"
                      controls
                      playsInline
                      webkit-playsinline="true"
                      preload="auto"
                      muted
                      poster="/galeri/video-yorum-poster.jpg"
                    >
                      <source src="https://pub-8e87fd3ea84544ddb1a9032553d5b084.r2.dev/video-homepage/video-yorum.mp4" type="video/mp4" />
                      Tarayıcınız bu videoyu oynatamıyor.
                    </video>
                  </div>
                </div>

              </div>
            </section>

            <section id="paketler" className="py-10 scroll-mt-16 md:scroll-mt-20">
              <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                <div className="rounded-2xl border border-rose-100 bg-white/70 backdrop-blur-sm p-6 text-center shadow-sm">
                  <h3 className="text-base sm:text-lg font-semibold text-neutral-900">
                    Fiyatları mı merak ediyorsunuz?
                  </h3>
                  <p className="mt-1 text-sm text-neutral-600">
                    İhtiyacınıza en uygun paketi görün, ödeme adımında detayları tamamlayın.
                  </p>
                  <div className="mt-4 flex justify-center">
                    <Link
                      to="/paketler"
                      className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-rose-400 to-[#e45078] px-7 py-2.5 text-sm font-bold text-white shadow-md hover:shadow-lg hover:from-rose-500 hover:to-rose-600 transition-all duration-300 hover:-translate-y-0.5"
                    >
                      ✨ Paketleri Gör
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            <FAQ />
          </Suspense>
        </div>

        <footer className="border-t border-rose-100 py-10 bg-white/50 backdrop-blur-sm">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

            {/* 1. ANA FOOTER İÇERİĞİ (SÜTUNLAR HALİNDE) */}
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-y-8 gap-x-6 text-sm">

              {/* Sütun 1: Şirket Bilgileri ve Sosyal (Opsiyonel) */}
              <div className="space-y-3 col-span-2 sm:col-span-1">
                <h4 className="text-base font-semibold text-neutral-800">Anora Forever</h4>
                <ul className="space-y-2 text-neutral-500">
                  <li>
                    <Link to="/hakkimizda" className="hover:text-rose-700 transition">
                      Hakkımızda
                    </Link>
                  </li>
                  <li>
                    <Link to="/iletisim" className="hover:text-rose-700 transition">
                      İletişim
                    </Link>
                  </li>
                  {/* Diğer şirket linkleri buraya gelebilir (kariyer, blog vb.) */}
                </ul>
              </div>

              {/* Sütun 2: Yasal Metinler (Ödeme Güveni İçin Kritik) */}
              <div className="space-y-3 col-span-2 sm:col-span-1">
                <h4 className="text-base font-semibold text-neutral-800">Yasal Bilgiler</h4>
                <ul className="space-y-2 text-neutral-500">
                  <li>
                    <Link to="/mesafeli-satis-sozlesmesi" className="hover:text-rose-700 transition">
                      Mesafeli Satış Sözleşmesi
                    </Link>
                  </li>
                  <li>
                    <Link to="/gizlilik-politikasi" className="hover:text-rose-700 transition">
                      Gizlilik Politikası
                    </Link>
                  </li>
                  <li>
                    <Link to="/teslimat-iade-sartlari" className="hover:text-rose-700 transition">
                      Teslimat ve İade
                    </Link>
                  </li>
                  <li>
                    {/* "Koşullar" linki büyük ihtimalle "Teslimat ve İade" ile çakışıyordur. 
                                Ancak mevcut olduğu için şimdilik tutuyoruz. */}
                    <Link to="/kosullar" className="hover:text-rose-700 transition">
                      Kullanım Koşulları
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* 2. GÜVEN VE TELİF HAKKI BÖLÜMÜ (ALT BANT) */}
            <div className="mt-10 pt-6 border-t border-rose-100 flex flex-col md:flex-row items-center justify-between gap-6">

              {/* Ödeme Logoları Alanı */}
              <div className="order-2 md:order-1 w-full md:w-auto">

                {/* Flex container: Yan yana dizer, ortalar ve aralarına boşluk koyar */}
                <div className="flex flex-wrap justify-center items-center gap-6">

                  {/* 1. Görsel: Troy/Mastercard/Visa bandı (Eğer tek görsel ise) */}
                  <img
                    src="../public/logo_band_colored@1X.png"
                    alt="Ödeme Seçenekleri"
                    className="h-8 w-auto object-contain"
                    loading="lazy"
                  />

                  {/* 2. Görsel: Diğer bant veya logo */}
                  <img
                    src="../public/logo_band_colored@12X.png"
                    alt="Ek Ödeme Seçenekleri"
                    className="h-8 w-auto object-contain"
                    loading="lazy"
                  />


                </div>
              </div>


              {/* Telif Hakkı (Ortalama ve sola yaslama) */}
              <div className="text-xs text-neutral-500 order-1 md:order-2">
                © {new Date().getFullYear()} Anora Forever. Tüm hakları saklıdır.
              </div>

            </div>
          </div>
        </footer>
      </main>
    </div >
  );
}